<template>
  <b-modal
    id="policy-modal"
    :visible="show"
    size="xl"
    centered
    scrollable
    no-close-on-backdrop
    no-close-on-esc
    hide-header
    hide-footer
    content-class="policy-modal-content"
    modal-class="policy-modal-wrapper"
  >
    <div class="policy-modal-body">
      <div class="policy-modal-header">
        <h3 class="policy-title mb-2">Политика конфиденциальности</h3>
        <div class="policy-subtitle">
          Payton.kz / Digital Galaxy Ltd. · Персональные данные и защита информации
        </div>
      </div>

      <div class="policy-text mt-3">
        <p>
          Настоящая Политика конфиденциальности (далее — «Политика») описывает, как Digital Galaxy Ltd.
          («Компания», «мы») собирает, использует, раскрывает и защищает персональные данные пользователей
          веб-сайта и сервисов платформы payton.kz.
        </p>
        <p>
          Политика применяется вместе с Условиями использования и иными документами, регулирующими
          предоставление услуг. Используя наши сервисы, вы подтверждаете, что ознакомились с настоящей
          Политикой и принимаете её условия.
        </p>

        <h5>1. Роль Компании и область действия</h5>
        <p>
          Digital Galaxy Ltd. выступает контролёром персональных данных и определяет цели и способы их
          обработки. Мы действуем законно, добросовестно и прозрачно, применяя соразмерные технические и
          организационные меры защиты в соответствии с законодательством Республики Казахстан.
        </p>

        <h5>2. Какие данные мы обрабатываем</h5>
        <h6>2.1. Данные, которые вы предоставляете</h6>
        <p>
          Вы сообщаете нам сведения при регистрации, открытии учётной записи, создании ордеров, обращениях в поддержку
          и при использовании интерактивных функций портала. Это может включать:
        </p>
        <ul>
          <li>фамилию, имя;</li>
          <li>адрес проживания, гражданство;</li>
          <li>реквизиты удостоверяющих документов, налоговое резидентство;</li>
          <li>контактные данные (телефон, e-mail);</li>
          <li>логин/псевдоним для доступа к платформе payton.kz;</li>
          <li>платёжные и банковские реквизиты (в т.ч. сведения, требуемые FATCA/CRS);</li>
          <li>дату и место рождения, сведения об образовании и занятости;</li>
          <li>статус политически значимого лица (ПДЛ), при наличии оснований;</li>
          <li>источники и размер дохода/пополнений;</li>
          <li>иные сведения, необходимые для соблюдения требований ПОД/ФТ и KYC.</li>
        </ul>
        <p>
          Для целей верификации личности вы также можете предоставить фото- или видеоматериалы.
        </p>

        <h6>2.2. Данные, собираемые автоматически</h6>
        <p>Мы можем автоматически получать:</p>
        <ul>
          <li>техническую информацию об устройстве и браузере (IP-адрес, версия ОС и браузера, часовой пояс);</li>
          <li>сведения о действиях на сайте (URL-переходы, просмотренные страницы, длительность сессии и др.);</li>
          <li>данные геолокации (при наличии разрешения на устройстве);</li>
          <li>агрегированные данные об использовании сервисов, транзакциях и комиссиях.</li>
        </ul>

        <h6>2.3. Данные из внешних источников</h6>
        <p>
          Мы можем получать сведения от аффилированных лиц и партнёров: платёжных провайдеров, служб доставки,
          аналитических и маркетинговых провайдеров, KYC/AML-поставщиков, агентств кредитного скоринга. Это
          позволяет подтвердить ранее предоставленную информацию и проверить финансовые организации, через
          которые производится пополнение/вывод средств.
        </p>
        <p>
          Обратите внимание: e-mail, псевдоним и иные данные, предоставленные при регистрации или незавершённой
          верификации, могут храниться для выполнения требований ПОД/ФТ и KYC.
        </p>

        <h5>3. Cookie-файлы</h5>
        <p>
          Подробности об используемых cookie, сроках их хранения и управлении согласием содержатся в нашей
          отдельной Политике cookie.
        </p>

        <h5>4. Для чего мы используем ваши данные</h5>
        <ul>
          <li>Оказание услуг: выполнение договорных обязательств, предоставление доступа к функциональности, поддержка пользователей.</li>
          <li>Безопасность: защита учётных записей и инфраструктуры, предотвращение мошенничества и злоупотреблений, мониторинг ИТ-систем.</li>
          <li>Администрирование и улучшение: диагностика и устранение неполадок, тестирование, аналитика, опросы, статистическая и продуктовая аналитика.</li>
          <li>Коммуникации: уведомления об изменениях в продуктах, сервисах и условиях.</li>
          <li>Маркетинг: информирование о релевантных предложениях Компании и/или партнёров (с учётом требований законодательства и вашего согласия, где оно необходимо).</li>
          <li>Правовые цели: ответы на запросы госорганов, защита прав и законных интересов, урегулирование претензий и споров.</li>
        </ul>
        <p>
          Мы также можем обрабатывать обезличенные данные для статистики и исследования рынка, в том числе с
          применением веб-маяков и пиксельных тегов.
        </p>

        <h5>5. Правовые основания обработки</h5>
        <ul>
          <li>ваше согласие (может быть отозвано в любое время);</li>
          <li>исполнение договора с вами;</li>
          <li>выполнение правовых обязательств (в т.ч. ПОД/ФТ);</li>
          <li>законные интересы Компании (безопасность, предотвращение мошенничества, развитие сервисов);</li>
          <li>регуляторные требования и отчётность;</li>
          <li>корпоративные сделки (слияния, приобретения и т.п.).</li>
        </ul>

        <h5>6. Маркетинг и коммуникации третьих лиц</h5>
        <p>
          Мы можем направлять информацию о новых продуктах Digital Galaxy Ltd. и предложениях партнёров, если
          это соответствует вашим интересам и требованиям законодательства. Для новых пользователей рассылки и
          передача данных третьим лицам в маркетинговых целях осуществляются при наличии согласия. Отказаться от
          маркетинговых сообщений можно в любой момент.
        </p>

        <h5>7. Раскрытие персональных данных</h5>
        <p>
          Персональные данные могут передаваться внутри группы Digital Galaxy Ltd. (аффилированные и дочерние
          компании), а также:
        </p>
        <ul>
          <li>деловым партнёрам, поставщикам и субподрядчикам для выполнения договоров и оказания услуг;</li>
          <li>кредитным агентствам, KYC/AML-провайдерам — для проверок и соблюдения законов;</li>
          <li>маркетинговым сетям — в виде агрегированной информации для таргетинга (без передачи конфиденциальных персональных данных).</li>
        </ul>
        <p>
          Мы также раскрываем данные при продаже/покупке активов или бизнеса, передаче активов Компании третьей
          стороне, выполнении требований закона и судебных актов, а также для защиты прав, собственности и
          безопасности Digital Galaxy Ltd., пользователей и третьих лиц.
        </p>

        <h5>8. Международная передача данных</h5>
        <p>
          Обработка и хранение данных могут осуществляться за пределами Республики Казахстан и/или ЕЭC. В таких
          случаях мы обеспечиваем адекватные гарантии защиты (договорные обязательства получателей, технические
          меры), сопоставимые с требованиями настоящей Политики.
        </p>

        <h5>9. Безопасность</h5>
        <p>
          Мы применяем организационные и технические меры защиты от несанкционированного доступа, утраты,
          изменения или раскрытия данных. Доступ предоставляется только уполномоченным сотрудникам по принципу
          «минимально необходимого объёма». Меры безопасности регулярно пересматриваются и совершенствуются.
        </p>

        <h5>10. Сроки хранения</h5>
        <p>
          Мы храним персональные данные столько, сколько требуется для целей их сбора и исполнения юридических и
          регуляторных обязанностей. Информация об учётной записи и ключевые записи учёта сохраняются не менее 5
          лет после прекращения использования услуг, если иные сроки не установлены законом.
        </p>
        <p>
          В отдельных случаях данные могут храниться дольше при наличии законного основания (официальный запрос,
          расследование, защита прав).
        </p>

        <h5>11. Ваши права</h5>
        <p>Вы вправе:</p>
        <ul>
          <li>получить доступ к своим данным и их копию;</li>
          <li>исправить неточные или неполные данные;</li>
          <li>требовать удаление данных (с учётом обязательных сроков хранения);</li>
          <li>ограничить обработку или возразить против неё;</li>
          <li>отозвать согласие, если обработка основана на согласии.</li>
        </ul>
        <p>
          Реализация отдельных прав может повлиять на возможность дальнейшего предоставления услуг.
        </p>

        <h5>12. Запросы субъекта данных</h5>
        <p>
          Запросы, связанные с доступом к данным или реализацией прав, направляйте на
          <a href="mailto:support@payton.kz">support@payton.kz</a>. В случае явно необоснованных/избыточных запросов
          или повторных запросов копий данных после первичного предоставления может взиматься разумная плата для
          покрытия административных расходов.
        </p>

        <h5>13. Ссылки на сторонние ресурсы</h5>
        <p>
          Наш портал может содержать ссылки на сайты третьих лиц. Мы не контролируем их политику и практики
          обработки данных. Перед передачей персональных данных рекомендуем ознакомиться с политиками
          конфиденциальности соответствующих сайтов.
        </p>

        <h5>14. Обновления Политики</h5>
        <p>
          Мы можем периодически изменять настоящую Политику. Актуальная версия всегда публикуется на данной
          странице; при существенных изменениях мы дополнительно уведомим вас по электронной почте или иным
          доступным способом. Рекомендуем регулярно проверять Политику на предмет обновлений.
        </p>
      </div>

      <div class="policy-footer mt-4">
        <!--
          Three independent consents required by Regulation §1.1 / §2 Step 1:
          User Agreement (Terms), Privacy Policy, and Risk Warning. Single
          combined checkbox cannot prove in court that the user specifically
          saw the Risk Warning, which is the most consequential of the three.
        -->
        <div class="policy-consents mb-3">
          <b-form-checkbox v-model="localTerms" class="mb-2">
            Я прочитал(а) и принимаю
            <a href="/#/terms" target="_blank" rel="noopener" class="policy-link">Пользовательское соглашение</a>
          </b-form-checkbox>
          <b-form-checkbox v-model="localPrivacy" class="mb-2">
            Я прочитал(а) и принимаю
            <a href="/#/policy" target="_blank" rel="noopener" class="policy-link">Политику конфиденциальности</a>
          </b-form-checkbox>
          <b-form-checkbox v-model="localRisk" class="mb-0">
            Я ознакомлен(а) и понимаю
            <a href="/#/risk" target="_blank" rel="noopener" class="policy-link">Предупреждение о рисках</a>
          </b-form-checkbox>
        </div>

        <div class="text-right">
          <b-button
            variant="outline-danger"
            class="mr-2"
            @click="$emit('logout')"
          >
            Выйти
          </b-button>
          <b-button
            variant="warning"
            class="px-4"
            :disabled="!allAccepted || loading"
            @click="onAccept"
          >
            <b-spinner small class="mr-2" v-if="loading"></b-spinner>
            <span v-if="!loading">Принять</span>
            <span v-else>Сохранение...</span>
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "PolicyModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localTerms: false,
      localPrivacy: false,
      localRisk: false,
    };
  },
  computed: {
    allAccepted() {
      return this.localTerms && this.localPrivacy && this.localRisk;
    },
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.localTerms = false;
        this.localPrivacy = false;
        this.localRisk = false;
      }
    },
  },
  methods: {
    onAccept() {
      if (!this.allAccepted || this.loading) return;
      this.$emit("accept", {
        terms: this.localTerms,
        privacy: this.localPrivacy,
        risk: this.localRisk,
      });
    },
  },
};
</script>

<style>
.policy-modal-wrapper .modal-dialog {
  max-width: 900px;
}

.policy-modal-content {
  border-radius: 20px;
  background: #141519;
  border: 1px solid rgba(239, 185, 20, 0.35);
  color: #e6e8ec;
  box-shadow: 0 40px 80px rgba(0, 0, 0, 0.65);
}

.policy-modal-body {
  padding: 24px 26px 22px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.policy-modal-header {
  border-bottom: 1px solid rgba(119, 126, 144, 0.45);
  padding-bottom: 10px;
}

.policy-title {
  color: #fcfcfd;
  font-weight: 700;
}

.policy-subtitle {
  color: #b1b5c3;
  font-size: 13px;
}

.policy-text {
  margin-top: 14px;
  padding-right: 6px;
  font-size: 13px;
  line-height: 1.5;
  color: #e6e8ec;
}

.policy-text h5 {
  margin-top: 14px;
  margin-bottom: 6px;
  font-size: 15px;
  font-weight: 600;
  color: #fcfcfd;
}

.policy-text h6 {
  margin-top: 10px;
  margin-bottom: 4px;
  font-size: 14px;
  font-weight: 600;
  color: #e6e8ec;
}

.policy-text p {
  margin-bottom: 8px;
}

.policy-text ul {
  padding-left: 1.1rem;
  margin-bottom: 8px;
}

.policy-footer {
  border-top: 1px solid rgba(119, 126, 144, 0.45);
  padding-top: 10px;
}
</style>

